import { SET_OPERATIONS } from './types';

const initialState = {
  operations: []
};

export function ZwalletOperationsReducer(state=initialState, action) {
  let payload;
  switch(action.type) {
    case SET_OPERATIONS:
      payload = action.payload;

      return {
        ...state,
        operations: [...payload]
      }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/reducers.js